import type { CurrentUser } from '@performance-crm/shared';
import { createContext, useContext } from 'react';

export interface AuthState {
  user: CurrentUser | null;
  loading: boolean;
}

export const AuthContext = createContext<AuthState>({ user: null, loading: true });

export function useAuth() {
  return useContext(AuthContext);
}
